import { useMemo } from 'react';
import { useAppSelector } from '../redux/hooks';
import useAuth from '../providers/Auth/Auth.provider';
import { EntityType } from '../redux/Global.model';

interface UseCheckDriverPayProps {
  entity: EntityType | null;
}

const useCheckDriverPay = ({ entity }: UseCheckDriverPayProps): boolean => {
  const {
    data: { userData }
  } = useAuth();
  const enableLtl = userData?.tenant?.ltl_enabled || false;
  const { trips, ltl_trips_in_order } = useAppSelector((state) => state.orders);
  const { selected_drivers } = useAppSelector((state) => state.trip);

  const anyDriverPayExists = useMemo(() => {
    if (!entity) {
      return false;
    }
    if (entity === EntityType.TRIP) {
      return !!selected_drivers?.some((driver) => driver.driver_pay_override_data);
    } else {
      let res = false;
      if (enableLtl) {
        res = !!ltl_trips_in_order.some((trip) =>
          trip.selected_drivers?.some((driver) => driver.driver_pay_override_data)
        );
      } else {
        res = !!trips.some((trip) =>
          trip.selected_drivers?.some((driver) => driver.driver_pay_override_data)
        );
      }

      return res;
    }
  }, [trips, selected_drivers, entity, ltl_trips_in_order]);

  return anyDriverPayExists;
};

export default useCheckDriverPay;
